(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AcuityDialogController', AcuityDialogController);

    AcuityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Acuity'];

    function AcuityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Acuity) {
        var vm = this;

        vm.acuity = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.acuity.id !== null) {
                Acuity.update(vm.acuity, onSaveSuccess, onSaveError);
            } else {
                Acuity.save(vm.acuity, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:acuityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
